import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { CART_SUGGESTION_TOKEN_EVENT_SENT } from '../../core/models/cookies.model';
import { AnalyticsEvent, AnalyticsService } from '../../core/services/analytics-service';
import { AddToCartEventSource } from '../models/add-to-cart-event-source.enum';

const CART_SUGGESTION_TOKEN = 'cart-suggestion-token';

@Injectable({
  providedIn: 'root',
})
export class CartSuggestionService {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cookies: CookieService,
    private analytics: AnalyticsService,
  ) {}

  public getCartSuggestionToken(): string {
    return this.route.snapshot.queryParamMap.get(CART_SUGGESTION_TOKEN);
  }

  public checkTokenAndRegisterEvent(token): void {
    if (!(this.getTokenCookie() === token)) {
      this.registerEvent(token);
      this.setCookie(token);
    }
  }

  public sendAddToCartAnalyticsEvent(): void {
    this.analytics.trackEvent(new AnalyticsEvent('Add to cart', AddToCartEventSource.CART_SUGGESTION));
  }

  public getCartSuggestionTokenPath(token: string): string {
    return '/liabilities/all?' + CART_SUGGESTION_TOKEN + '=' + token;
  }

  private getTokenCookie(): string {
    return this.cookies.get(CART_SUGGESTION_TOKEN_EVENT_SENT);
  }

  private setCookie(token): void {
    const expires = new Date();
    expires.setTime(expires.getTime() + 1000 * 60 * 60 * 24 * 30);
    this.cookies.put(CART_SUGGESTION_TOKEN_EVENT_SENT, token, { expires });
  }

  private registerEvent(token): void {
    this.analytics.trackEvent(new AnalyticsEvent('cart_suggestion_redirect', { token }));
  }

  public getCartSuggestionTokenFromSnapshot(next: ActivatedRouteSnapshot): string {
    return next.queryParams[CART_SUGGESTION_TOKEN];
  }

  public redirectToCartSuggestion(token: string): Promise<boolean> {
    const queryParams = {};
    queryParams[CART_SUGGESTION_TOKEN] = token;
    return this.router.navigate(['/liabilities/all'], { queryParams });
  }
}
